var React = require('react');

function Information (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"m28.087 2h-26.087v33.884h26.087v-33.884z","key":0}),React.createElement("path",{"d":"m35.913 2v18.245h26.087v-18.245h-26.087z","key":1}),React.createElement("path",{"d":"m28.087 62v-18.245h-26.087v18.245h26.087z","key":2}),React.createElement("path",{"d":"m35.913 28.116v33.884h26.087v-33.884h-26.087z","key":3})]));
}

Information.defaultProps = {"clipRule":"evenodd","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","version":"1.1","viewBox":"0 0 64 64","xmlSpace":"preserve"};

module.exports = Information;

Information.default = Information;
